import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createSalesChannel } from 'services/api/requests/requests';

import { mapErrorToToastProps } from '../../../utils/forms/mapErrorToToastProps';

export const useCreateSalesChannel = (
	form?,
	setForm?,
	formProps?,
	setCanalVendaId?
) => {
	const queryClient = useQueryClient();
	const toast = useToast();

	return useMutation(createSalesChannel, {
		onSuccess: success => {
			queryClient.invalidateQueries(['commercialHierarchy-list']);
			toast({
				title: 'Criado com sucesso!',
				description: 'Canal de Venda criado com sucesso.',
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});
			if (form && setForm) {
				setForm({
					...form,
					canalVenda: success.id,
				});
			}
			if (formProps) {
				const { setValue } = formProps;
				setValue('canal_venda', success?.id);
			}
			if (setCanalVendaId) {
				setCanalVendaId(success?.id);
			}
		},
		onError: (error: any, variables, context) => {
			const toastErrors: Array<any> = mapErrorToToastProps(
				error,
				'Erro ao cadastrar Canal de Venda!'
			);
			toastErrors?.forEach(element => toast(element));
		},
	});
};
